import { ITableColumn, TableColumnTypeEnum, WidthType } from './tableColumn.interface';

export const agentStepsActivityTableColumns: ITableColumn[] = [
  {
    labelPath: 'aiAgentStepActivityPage.tableColumns.timestamp',
    propertyKey: 'timestamp',
    colType: TableColumnTypeEnum.Text,
    width: 324,
    widthType: WidthType.Pixel,
    isSortable: true,
    sortKey: 'timestamp',
  },
  {
    labelPath: 'aiAgentStepActivityPage.tableColumns.actorName',
    propertyKey: 'actorName',
    colType: TableColumnTypeEnum.Text,
    width: 232,
    widthType: WidthType.Pixel,
    isSortable: true,
    sortKey: 'mainActor',
  },
  {
    labelPath: 'aiAgentStepActivityPage.tableColumns.agentName',
    propertyKey: 'agentName',
    colType: TableColumnTypeEnum.Text,
    width: 308,
    widthType: WidthType.Pixel,
    isSortable: false,
    sortKey: 'aiAgentDisplayName',
  },
  {
    labelPath: 'aiAgentStepActivityPage.tableColumns.stepType',
    propertyKey: 'stepType',
    colType: TableColumnTypeEnum.TextWithIcon,
    width: 294,
    widthType: WidthType.Pixel,
    isSortable: true,
    sortKey: 'stepType',
    iconSrc: 'blockedStepIcon',
    iconAlt: 'blockedStepIconAlt',
    textColor: 'blockedStepTextColor',
    iconTableClass: 'blockedIconStyleClass',
  },
  {
    labelPath: 'aiAgentStepActivityPage.tableColumns.clientApplication',
    propertyKey: 'clientApplication',
    colType: TableColumnTypeEnum.TextWithIcon,
    width: 300,
    widthType: WidthType.Pixel,
    iconSrc: 'clientApplicationIcon',
    isSortable: true,
    sortKey: 'clientApplication',
  },
  {
    labelPath: 'aiAgentStepActivityPage.tableColumns.threadId',
    propertyKey: 'threadId',
    colType: TableColumnTypeEnum.CopyableText,
    width: 156,
    widthType: WidthType.Pixel,
    isSortable: false,
    withCopyIcon: true,
    iconOnly: true,
  },
];
